import { de as sharedDe } from '@piaas/piaas-ui-toolkit/i18n';

import appDe from './app/de';

export default { ...sharedDe, ...appDe };
